/**
* 单任务在班级内的详情
*/
<template>
    <span>
       <!-- <el-button type="button" @click="openmodel()">考勤情况</el-button> -->
		 <a-button :loading="loading" @click="openmodel" type="primary" style="margin-bottom: 10px; margin-left: 10px;">考勤情况</a-button>
        <a-modal :visible="visible" :width="1280" destroyOnClose title="班级考勤情况" @ok="okmodel" @cancel="cancelmodel">
		
         
            <div>
              <!-- {{tabledata}} --><!-- {{tabledata}} -->
			<!--  {{tabledata}} -->
				 <table>
				    <thead>
				      <tr>
						<th class="tableth" >姓名</th>
						
				        <th class="tableth" v-for="column in columns" :key="column">{{ column['kq_time']}}</th>
				      </tr>
				    </thead>
				    <tbody>
						
				    <tr v-for="row in tabledata" :key="row.user.org_user_id">
					<!-- 	{{row.user}} -->
						<td class="tabletd">{{row.user.user_name}}</td>
				        <td class="tabletd" :class="'tdback'+getProblemIsRight(row, index)" v-for="(column,index) in columns" :key="column">{{tihuan(getProblemIsRight(row, index))}}</td>
				      </tr> 
				    </tbody>
				  </table>
                <div>总共{{ pageinfo.total }}条数据</div>
                <a-switch size="small" v-model="showcount" @change="getshowcount" />
            </div>
          
        </a-modal>
    </span>
</template>
<script>
//   import  squadusermodel from '@/views/orgpublish/squadusermodel.vue';

export default {
    
    props: {
        itemdata: {},
        squad_id: undefined,
       
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
			columns:[],
            showcount: false,
            tabledata: [],
            loading: false,
            visible: false,
            squadinfo: [],
            missioninfo: [],
            usermission: [],
            questionList: [],
        };
    },
    mounted() {

    },
    computed: {

    },
    methods: {

       
        getshowcount() {
            if (this.showcount) {
                this.pageinfo.pageSize = 9999;
                this.pageinfo.current = 1;
                // this.showcount=true;
            }
            if (!this.showcount) {
                this.pageinfo.pageSize = 10;
                this.pageinfo.current = 1;
                // this.showcount=false;
            }
            this.getTableList();
        },
		
		
       
        getTableList() {
            this.loading = true;
            this.$axios
                .post("/api/OrgSquad/getkaoqinbysquad", {
                    data: {
                        squad_id: this.itemdata.id
                    },
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.tabledata = null;
                    } else {
                        this.tabledata = res.data['tr'];
						this.columns=res.data['td']
                      //  this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        openmodel() {
            this.visible = true;
            // this.getmissioninfo();
            // this.getsquadinfo();
             this.getTableList();
        },
		getProblemIsRight(row, colIndex) {
			//colIndex;
			//return row.problems;
		      if (row.kqinfo && row.kqinfo.length > 0) {
		        const kqinfo = row.kqinfo[colIndex];
		        if (kqinfo) {
					if(kqinfo.status==0)
					{
					// 	if(problem.correct==1)
					// 	{
					// return problem.isright;
					// 	}
					// 	else{
					// 		return 2;
					// 	}
					return 1;
					}
					else if(kqinfo.status==1)
					{
						return 2
					}
					else if(kqinfo.status==2){
						return 3;
					}
					else{
						return 4;
					}
		        }
				
		      }
		      
		    },
		tihuan(xx)
			{
				
				if(xx==1)
				{
					return "✓"
				}
				if(xx==2)
				{
					return "调课"
				}
				if(xx==3)
				{
					return "请假"
				}
				if(xx==4)
				{
					return "未加入"
				}
				
			},
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },


    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
.tableth {
    width: 100px; /* 设置宽度 */
    height: 50px; /* 设置高度 */
    border: 1px solid black; /* 设置边框样式 */
	text-align: center; 
  }
.tabletd {
      width: 100px; /* 设置宽度 */
      height: 50px; /* 设置高度 */
      border: 1px solid black; /* 设置边框样式 */
	  text-align: center; 
 }
 .tdback0
 {
  background-color: red;	 
 }
 .tdback2
 {
  background-color: green; /* 设置背景颜色为绿色 */	 
 }
 .tdback3
 {
  background-color: yellow;/* 设置背景颜色为绿色 */	 
 }
 .tdback4
 {
  background-color:burlywood;/* 设置背景颜色为绿色 */	 
 }
</style>
